module.exports = __webpack_public_path__ + "026.7f5082dd.png";